import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation setQuoteBrandingDefaultMutation($input: SetQuoteBrandingDefaultInput!) {
		setQuoteBrandingDefault(input: $input) {
			company {
				id
				quoteBrandingDefault {
					accentColor
					font
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
